import { render, staticRenderFns } from "./video-player.vue?vue&type=template&id=f907fa1c&"
import script from "./video-player.vue?vue&type=script&lang=ts&"
export * from "./video-player.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports